import React, { useContext, useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import { CalendarContext } from '../../../pages/Activity/context/CalendarProvider';
import { EventContext } from '../../../pages/Activity/context/EventProvider';
import TodayEventDisplay from './components/TodayEventDisplay/TodayEventDisplay';
import Legends from './components/Legend/Legends';

// Import SCSS and CSS
import 'react-calendar/dist/Calendar.css';
import './SmallCalendar.scss';

export default function SmallCalendarSection() {
  const { selectedDate, setSelectedDate } = useContext(CalendarContext);
  const { eventDetailsMapped, getDayEventDetails } = useContext(EventContext);

  const [customSelectedDate, setCustomSelectedDate] = useState(new Date());
  const [activeStartDate, setActiveStartDate] = useState(new Date());

  // Set the active start date to match the selected date in context
  useEffect(() => {
    if (selectedDate) {
      setActiveStartDate(
        new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1),
      );
    }
  }, [selectedDate]);

  // Handle tile class name for the calendar
  const handleTileClassName = ({ date, view }) => {
    if (view === 'month') {
      // Build the UTC‐midnight span for this tile’s calendar day
      const tileStartUTC = Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        0,
        0,
        0,
        0,
      );
      const tileEndUTC = tileStartUTC + 24 * 60 * 60 * 1000 - 1;

      const hasEvent = eventDetailsMapped.some(event => {
        const evStart = Date.parse(event.StartTime); // UTC ms
        const evEnd = Date.parse(event.EndTime);
        // overlap if event span intersects tile span
        return evEnd >= tileStartUTC && evStart <= tileEndUTC;
      });

      return hasEvent ? 'has-event' : null;
    }
    return null;
  };

  // Change the original navigation label to show my custom label
  const handleNavigationLabel = ({ date }) => {
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return (
      <div className="react-calendar-date-header d-flex justify-content-start">
        <span>{`${month} ${year}`}</span>
      </div>
    );
  };

  // Handle date click to set the custom selected date
  const handleDateClick = date => {
    setCustomSelectedDate(date);
    setSelectedDate(date);
  };

  useEffect(() => {
    if (selectedDate) {
      setCustomSelectedDate(new Date(selectedDate));
    }
  }, [selectedDate]);

  return (
    <div className="small-calendar-section d-flex flex-column">
      <Calendar
        onClickDay={handleDateClick}
        value={customSelectedDate}
        activeStartDate={activeStartDate}
        tileClassName={handleTileClassName}
        nextLabel={null}
        prevLabel={null}
        next2Label={null}
        prev2Label={null}
        navigationLabel={handleNavigationLabel}
        formatShortWeekday={(locale, date) =>
          date.toLocaleDateString(locale, { weekday: 'narrow' })
        }
      />
      <div className="event-details mt-2 px-2">
        {getDayEventDetails(customSelectedDate).length > 0 ? (
          <div className="event-list">
            <TodayEventDisplay
              events={getDayEventDetails(customSelectedDate)}
              todayDate={customSelectedDate}
            />
          </div>
        ) : (
          <div className="no-events fw-semibold">
            <span>No events for this day</span>
          </div>
        )}
      </div>
      {/* Legend */}
      <div className="legend-container py-1">
        <Legends />
      </div>
    </div>
  );
}
